import { render, staticRenderFns } from "./InputBasic.vue?vue&type=template&id=1f5e5ffd&scoped=true"
import script from "./InputBasic.vue?vue&type=script&lang=js"
export * from "./InputBasic.vue?vue&type=script&lang=js"
import style0 from "./InputBasic.vue?vue&type=style&index=0&id=1f5e5ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e5ffd",
  null
  
)

export default component.exports